export default __webpack_public_path__ + "images/get_started_design.4ce15f4e2bc6ecaf54ff1497ac1859c9.svg";